const url = '/agentCommissionAccounts';
const Provider = 'AgentCommissionAccounts';
const dbModel = 'AgentCommissionAccounts';

export { url, Provider, dbModel };
